import type { IconSvgObject } from './types';

const RowDeleteIcon: IconSvgObject = [
  ["path", { d: "M21 8L15 2M21 2.00088L15 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 11H5C3.89543 11 3 10.1046 3 9V6C3 4.89543 3.89543 4 5 4H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 15H5C3.89543 15 3 15.8954 3 17V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V17C21 15.8954 20.1046 15 19 15Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RowDeleteIcon;
